import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { ButtonLink } from "@/lib/ButtonLink"
import {
  navbarHeaderIconButtonSize,
  navbarHeaderIconSize,
} from "@/widgets/layout/NavbarPartners"
import { NotificationBell } from "@/widgets/notifications/NotificationBell"

const headerIconButtonClass = `border-0 ${navbarHeaderIconButtonSize}`

export type NavbarAuthAreaProps = {
  isAuthenticated: boolean
  headerTone: "transparent" | "solid"
  onLogout: () => void
}

export const NavbarAuthArea = ({
  isAuthenticated,
  headerTone,
  onLogout,
}: NavbarAuthAreaProps) => {
  const { t } = useTranslation()
  const location = useLocation()
  const isLoginActive = location.pathname === "/login"

  if (isAuthenticated) {
    return (
      <>
        <NotificationBell headerTone={headerTone} />
        <ButtonLink
          variant="navPillOutline"
          pillSize="iconAlways"
          headerTone={headerTone}
          className={headerIconButtonClass}
          onClick={onLogout}
          aria-label={t("nav.logout")}
        >
          <i className={`ri-logout-box-r-line ${navbarHeaderIconSize}`} aria-hidden />
        </ButtonLink>
      </>
    )
  }
  return (
    <ButtonLink
      to="/login"
      variant="navPillOutline"
      pillSize="iconAlways"
      headerTone={headerTone}
      className={headerIconButtonClass}
      isActive={isLoginActive}
      aria-label={t("nav.login")}
    >
      <i className={`ri-login-box-line ${navbarHeaderIconSize}`} aria-hidden />
    </ButtonLink>
  )
}
